import Tabs from "@/components/Tabs";
import useDashboardGreeting from "@/hooks/useDashboardGreeting";
import { useShowRosterDashboardTab } from "@/features/roster-activity";
import { Path, useNavigate } from "@/router";
import { Outlet, useLocation } from "react-router-dom";
import DashboardTabIcon from "./_components/DashboardTabIcon";
import { HOME_DASHBOARD_OVERVIEW_PATH, SECTION_ROSTER_DASHBOARD_PATH } from "./constants";

/**
 * Home dashboard tab bar: icon Home tab + optional Roster tab.
 *
 * Design reference: https://le-section-dashboard-prototype.m360.dev.pgahq.com/home/roster
 */
function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export default function HomeDashboardTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const greeting = useDashboardGreeting();
  const showRosterTab = useShowRosterDashboardTab();
  const currentPath = normalizePathname(location.pathname);

  if (!showRosterTab) {
    return <Outlet />;
  }

  const homeActive = currentPath === HOME_DASHBOARD_OVERVIEW_PATH;
  const rosterActive = currentPath.startsWith(SECTION_ROSTER_DASHBOARD_PATH);
  const preservedSearch = location.search;

  const tabItems = [
    {
      label: "Home",
      iconOnly: true,
      icon: <DashboardTabIcon materialIcon={greeting.tabIcon} />,
      active: homeActive,
      testId: "tab-home",
      onClick: () => navigate(`${HOME_DASHBOARD_OVERVIEW_PATH}${preservedSearch}` as Path)
    },
    {
      label: "Roster",
      active: rosterActive,
      testId: "tab-roster",
      onClick: () => navigate(`${SECTION_ROSTER_DASHBOARD_PATH}${preservedSearch}` as Path)
    }
  ];

  return (
    <div data-testid="home-dashboard-tabs">
      <Tabs tabItems={tabItems} />
      <Outlet />
    </div>
  );
}
